import { locale } from '../../Services/Tools/reducers';

export const dashboard = {
  timer: {
    isEnable: true,
    interval: 100000,
  },
  strings: locale('fr', 'dashboard'),
  defaultWidgets: [
    // {
    //   component: 'DlpkDashboardCard',
    //   position: 1,
    //   config: {
    //     title: 'Selection du produit',
    //     icon: 'search',
    //     label: 'Cliquez ici',
    //     link: '/surveys/new',
    //     fill: '#3d93cd',
    //   },
    // },
    {
      component: 'DlpkDashboardCard',
      position: 2,
      config: {
        title: 'Nouvelle Tarification',
        icon: 'euro',
        label: 'Cliquez ici',
        link: '/salesroutes/new',
        fill: '#3d93cd',
      },
    },
  ],
  widgets: [],
};
